import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { PostHogProvider } from 'posthog-js/react'

import App from './App.tsx'
import './App.css'

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const workerUrl = import.meta.env.DEV ? '/sw-dev.js' : '/sw.js'
    navigator.serviceWorker.register(workerUrl).catch(() => {
      // Service worker registration failed - app will still work
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {POSTHOG_KEY ? (
      <PostHogProvider
        apiKey={POSTHOG_KEY}
        options={{
          api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
          defaults: '2025-11-30',
          capture_exceptions: true,
          debug: import.meta.env.MODE === 'development',
        }}
      >
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </PostHogProvider>
    ) : (
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    )}
  </StrictMode>,
)
